module.exports = __webpack_public_path__ + "static/media/up_Arrow.de7538d9.svg";